// src/pages/User.js
import axios from 'axios';
import { Box, Container, Typography, CircularProgress, Alert } from '@mui/material';
import { useState, useEffect } from 'react';
import DriversTable from '../components/tables/DriversTable';

const User = () => {
  // 預設為空陣列
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const Region = localStorage.getItem('region');

  const fetchDriverScores = async () => {
    try {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');

      const response = await axios.get(
        `https://api.smartbustw.com/DriverScore/scores/${Region}/${year}/${month}/summary`
      );
      setDrivers(response.data.scores || []); // 如果 response.data.scores 為 null/undefined，使用空陣列
      setLoading(false);
    } catch (err) {
      setDrivers([]); // 錯誤時設置空陣列
      setLoading(false);
      console.error('Error fetching driver scores:', err);
    }
  };

  useEffect(() => {
    fetchDriverScores();
  }, []);

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          駕駛評分總表
        </Typography>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* 即使有錯誤也會顯示空表格 */}
        <DriversTable drivers={drivers} />
      </Box>
    </Container>
  );
};

export default User;